export function checkProps(prevProps, nextProps) {
  return (
    prevProps.lng === nextProps.lng &&
    prevProps.planType === nextProps.planType &&
    prevProps.expiryDate === nextProps.expiryDate &&
    prevProps.points === nextProps.points
  )
}
